import React from "react";

import { PostInterface } from "src/store/community/postsSlice";
import Meta, { MetaInterface } from "src/componets/Meta";
import IconText from "src/componets/IconText";
import { DownloadOutlined, HeartOutlined, LikeOutlined, MessageOutlined } from "@ant-design/icons";
import StatsIcons from "src/componets/StatsIcons";
import { HiddenTag } from "../../../../componets/Tags/HiddenTag";

interface _MetaInterface {
  post: PostInterface | undefined;
  size?: MetaInterface['size'];
  shape?: MetaInterface['shape'];
  showStats?: boolean;
}

const _Meta = ({ post, shape, size, showStats }: _MetaInterface) => {
  let description: any = null;

  if (!post) {
    return null;
  }

  if (showStats) {
    description = (
      <div>
        <div className='v-sticker-pack-table-list--statuses'>
          <HiddenTag hidden={!post.published} />
        </div>

        <StatsIcons
          icons={[
            <IconText tooltip='popular' icon={HeartOutlined} text={post?.popular_count} />,
            <IconText tooltip='likes' icon={LikeOutlined} text={post?.likes_count} />,
            <IconText tooltip='comments' icon={MessageOutlined} text={post?.comments_count} />,
            <IconText tooltip='downloads' icon={DownloadOutlined} text={post?.downloads_count} />
          ]}
        />
      </div>
    )
  }

  return (
    <Meta
      url={post.url}
      size={size}
      shape={shape}
      avatar={post.thumbnail_url}
      title={post.title}
      description={description}
    />
  );
}

export default _Meta;
